module.exports = __webpack_public_path__ + "static/img/20004 (2).5d71d82.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20004 (2).webp
// module id = LVOg
// module chunks = 14